import { AiFormFieldCaller } from './ai-form.types';
import { AI_FORM_OPTIONS_PAGE_SIZE, fetchAiFormOptions } from './ai-form-field-callers';

export const companySpotOption = (spot: any) => ({
    id: `${spot.company.id}:${spot.id}`,
    label: [spot.company.shortName || spot.company.name, spot.type?.name, spot.name].filter(Boolean).join(' '),
});

export const companySpots: AiFormFieldCaller = async (query, { state, signal }) => {
    const params = new URLSearchParams({ page: String(query.page ?? 1), pageSize: String(AI_FORM_OPTIONS_PAGE_SIZE), orderBy: 'name' });
    if (query.search) params.set('search', query.search);
    if (state?.entityId != null) params.set('forUserSpot', String(state.entityId));
    if (query.ids) {
        if (query.ids.some(id => !/^\d+:\d+$/.test(id))) throw new Error('Некорректный ID компании/офиса');
        new Set(query.ids.map(id => id.split(':')[0])).forEach(id => params.append('ids', id));
    }
    const data = await fetchAiFormOptions(`/core/refbooks/companies.json?${params}`, signal);
    if (!Array.isArray(data.companies)) throw new Error('Некорректный ответ списка компаний');
    const items = data.companies.flatMap(company => (company.spots ?? []).map(spot => ({
        ...spot, company: { id: company.id, name: company.name, shortName: company.shortName },
    }))).filter(spot => !query.ids || query.ids.includes(companySpotOption(spot).id));
    return { items, hasMore: !query.ids && data.page * data.pageSize < data.totalCount };
};
